import { render, staticRenderFns } from "./AddressDetailsDashboard.vue?vue&type=template&id=4bcfd344&"
import script from "./AddressDetailsDashboard.vue?vue&type=script&lang=js&"
export * from "./AddressDetailsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports